import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
var InstructionsComponent = /** @class */ (function () {
    function InstructionsComponent(_route, _router, _userService, store, _sidenavService, storeF) {
        this._route = _route;
        this._router = _router;
        this._userService = _userService;
        this.store = store;
        this._sidenavService = _sidenavService;
        this.storeF = storeF;
        this.imgSrc = "assets/permisos/document.svg";
        this.forms = [];
        this.materias = [];
        this.iconosPermisos = ["assets/permisos/obramenor.svg", "assets/permisos/edificacion.svg", "assets/permisos/houses.svg",
            "assets/permisos/parquet.svg", "assets/permisos/profiles.svg", "assets/permisos/landslide.svg", "assets/permisos/antenna.svg",
            "assets/permisos/worker.svg", "assets/permisos/fire-station.svg"];
        // this.getFormUsed();  
        this.getFormularios();
    }
    InstructionsComponent.prototype.ngOnInit = function () {
        if (!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')) {
            this._router.navigate(['/']);
        }
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
        if (localStorage.getItem("form")) {
            this.active = false;
        }
        else {
            this.active = true;
        }
    };
    /*  getForm(id, title) {
       localStorage.clear();
       sessionStorage.removeItem('borrador');
       this.store.dispatch(new FormActions.FormUpdate(id, title))
       localStorage.setItem("form", id)
   
   
     } */
    InstructionsComponent.prototype.ngDoCheck = function () {
        this.numberForm = localStorage.getItem("form");
        if (localStorage.getItem("form")) {
            this.existForm = true;
        }
        else {
            this.existForm = false;
        }
    };
    InstructionsComponent.prototype.getFormUsed = function () {
        var _this = this;
        this._userService.getFormUser().subscribe(function (response) {
            _this.forms = response;
        }, function (error) {
            console.log(error);
        });
    };
    InstructionsComponent.prototype.openForms = function (num) {
        this._sidenavService.toggle();
        sessionStorage.setItem("expandedItem", num);
    };
    InstructionsComponent.prototype.getFormularios = function () {
        var _this = this;
        this._userService.getFormularios().subscribe(function (response) {
            _this.materias = response.materias;
            // console.log("response", response.materias)
            // console.log("response.materias[0].name", response.materias[0].name)
        }, function (error) {
            console.log("main-nav.component.ts error", error);
        });
    };
    InstructionsComponent.prototype.getForm = function (id, title, online) {
        var _this = this;
        console.log(id, title, online);
        if (online) {
            localStorage.clear();
            sessionStorage.removeItem('borrador');
            this.store.dispatch(new FormActions.FormUpdate(id, title));
            this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
                newFormValues: {
                    formulario: '1.1',
                    tipo_solicitud: 'prueba',
                }
            }));
            setTimeout(function () {
                _this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
                    newFormValues: {
                        proyectos: []
                    }
                }));
            }, 2000);
            localStorage.setItem("form", id);
            this._userService.formMostUsed(id, title).subscribe(function (response) {
                console.log(response);
            }, function (error) {
                console.log(error);
            });
        }
        else {
            alert("El formulario seleccionado solo se puede realizar presencialmente");
        }
    };
    return InstructionsComponent;
}());
export { InstructionsComponent };
